// extracted by mini-css-extract-plugin
module.exports = {"FXPair":"FXPair_FXPair__3AJU0","CurrencyCode":"FXPair_CurrencyCode__35Wfb","CurrencyName":"FXPair_CurrencyName__3IpMx","fXRate":"FXPair_fXRate__3G3-Q"};